Vue.component('auto-complete', {
    template: '<div>\
                <input @input="empty=false" :id="placeholder" type="text" :class="{error: empty}" class="required busAutoComplete clear_input" :value="selected.city" :placeholder="placeholder" autocomplete="on" autocorrect="off" autocapitalize="off"/>\
                <label v-if="empty" :class="{error: empty}" :for="placeholder">{{errorMessage}}</label>\
               </div>',
    props: ['placeholder', 'departure', 'selected', 'error'],
    data: function(){
        return {
            empty: false,
            selection: {
                city: '',
                cityId: 0,
            },
        }
    },
    mounted: function () {
        this.createAutoComplete();
    },
    computed: {
      errorMessage: function () {
          return FmtMessage.getMessage('js.general.required');
      }
    },
    methods: {
        createAutoComplete: function(){
            var vm = this;
            var id = '#' + this.placeholder;
            $(id).autocomplete({
                minLength: 2,
                source: function(request, response) {
                    vm.fetchCities(response, request.term);
                },
                select : function(event, ui) {
                    vm.updateSelected(ui.item);
                },
                open: function(event, ui) {
                    $(vm.$el).off('menufocus hover mouseover mouseenter');
                }
            });
        },
        fetchCities: function (autoComplete, param) {
            var searchParams = null;
            if (!this.departure){
                searchParams = {
                    output : 'json',
                    searchKey : param
                }
            }
            else{
                searchParams = {
                    output : 'json',
                    searchKey : param,
                    departurePoint: this.departure
                }
            }

            return $.ajax({
                url : "/bus/departure/autocomplete/json",
                dataType : "json",
                data : searchParams
            })
            .then(function (response) {
                var cities = response.map(function (item) {
                    return {
                        value :  item.locationCode,
                        cityId : item.cityId
                    };
                });
                autoComplete(cities);
            })
            .fail(function (error) {
                return [];
            });
        },
        updateSelected : function (data){
            var selectedData = {
                city: data.value,
                cityId: data.cityId
            };
            this.$emit('input', selectedData);
        }
    },
    watch: {
        error: function (nval, oval) {
            this.empty = nval;
        }
    }
});
//